@if (formGroup) {
  <form [formGroup]="formGroup" class="grid grid-cols-2 gap-3">
    <em-select formControlName="operator" [subscriptSizing]="'dynamic'">
      <em-option [value]="null"> </em-option>
      @for (operator of operators; track $index) {
        <em-option [value]="operator.name">
          {{ 'G_FILTER_' + operator.name.toUpperCase() + '_VALUE' | translate }}
        </em-option>
      }
      <em-error>{{ 'SHARED_REQUIRED_FIELD' | translate }}</em-error>
    </em-select>

    <em-input
      formControlName="value"
      [subscriptSizing]="'dynamic'"
      [step]="1"
      type="number"
    >
      <em-error>{{ 'SHARED_REQUIRED_FIELD' | translate }}</em-error>
    </em-input>

    <em-select
      formControlName="source"
      [subscriptSizing]="'dynamic'"
      [label]="'SHARED_LABEL_SOURCE' | translate"
    >
      <em-option [value]="null"> </em-option>
      @for (source of sources; track $index) {
        <em-option [value]="source.id">
          {{ source.name }}
        </em-option>
      }
    </em-select>
  </form>
}
